import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUserIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#06051E" fillRule="evenodd" clipPath="url(#a)" clipRule="evenodd">
      <path d="M12 6a3.429 3.429 0 1 0 0 6.857A3.429 3.429 0 0 0 12 6M6.857 9.429a5.143 5.143 0 1 1 10.286 0 5.143 5.143 0 0 1-10.286 0" />
      <path d="M12 17.145a7.71 7.71 0 0 0-6.588 3.7.857.857 0 1 1-1.464-.89 9.428 9.428 0 0 1 16.104 0 .857.857 0 1 1-1.464.89 7.71 7.71 0 0 0-6.588-3.7" />
      <path d="M12 1.714C6.32 1.714 1.714 6.32 1.714 12S6.32 22.286 12 22.286 22.286 17.68 22.286 12 17.68 1.714 12 1.714M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgUserIcon;
